import { Box, Divider, Flex } from '@chakra-ui/react';
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckFormInput from '../../../forms/TextInputField/components/LaunchdeckFormInput';


export default function PublicDsrJoinRoomCreateUserForm({ handleCreateRoomJoiner, onChangeHandler, showCreatedPasswordInputError, showNameInputError,
	joinerNameInput,
	createdPasswordInput,
	companyNameInput,
	companyRoleInput,
	isProcessing
}) {

	return (
		<Box w='100%' maxW='25em'>
			<Box fontSize='1em' color='brandDark.500' fontWeight='600' mt='1em' textAlign='center'>
				Introduce yourself
			</Box>

			<Box fontSize='0.875em' color='gray.500' mb='1em' textAlign='center'>
				Help others get to know you
			</Box>

			<Box w="100%" align="center" mt='2.5em'>
				<Box px='1em' mt='1em'>

					<Box mt='1em' w='100%'>
						<LaunchdeckFormInput
							label='Your name'
							isRequired={true}
							name={'joiner-name-input'}
							onChange={onChangeHandler}
							value={joinerNameInput || ""}

							isDisabled={isProcessing}
							autoFocus={true}

							errorLogic={showNameInputError}
							errorMessage="Help Room members know how to address you"
			
						/>

					</Box>

					<Box mt='1em' w='100%'>
						<LaunchdeckFormInput
							label='Create a password'
							isRequired={true}
							name={'created-password-input'}
							onChange={onChangeHandler}
							value={createdPasswordInput || ""}
							type="password"

							isDisabled={isProcessing}

							errorLogic={showCreatedPasswordInputError}
							errorMessage="Please consider a longer password"
						/>
					</Box>

					<Flex mt='1em' w='100%' justify='flex-end' color='brandPink.500' fontSize='0.75em'>
						* Required
					</Flex>
					<Divider my='0.5em' />

					<Box mt='1em' w='100%'>

						<LaunchdeckFormInput
							label='Company name'
							name={'company-name-input'}
							onChange={onChangeHandler}
							value={companyNameInput || ""}
							placeholder={'e.g. Acme Inc'}

							isDisabled={isProcessing}
						/>
					</Box>

					<Box mt='1em' w='100%'>
						<LaunchdeckFormInput
							label='Company title'
							name={'company-role-input'}
							onChange={onChangeHandler}
							value={companyRoleInput || ""}
							placeholder={'e.g. Purchasing Director'}

							isDisabled={isProcessing}
						/>
					</Box>
				</Box>

				<Flex w='100%' mt='2em' px='1em' pt='0.625em' pb='2em'>
					<Flex justify='center' w='100%'>
						<LaunchdeckButton bg='brand.500' color='gray.50' w='100%' label='Enter Room' loadingLogic={isProcessing} onClick={() => handleCreateRoomJoiner()} />
					</Flex>
				</Flex>

			</Box>
		</Box>

	);
};


